import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { mapStateToProps } from '../components/QueryFilterContainer';
import CohortFilterValue from './CohortFilterValue';
import { translatedOperator } from '../helper';
import { cohortFilters } from '../constants';

const QueryFilterOperatorCell = ({
  code,
  category,
  operator,
  type,
  canRead,
  canEdit,
  width,
}) => {
  const intl = useIntl();
  const filters = cohortFilters[type];
  const translated = translatedOperator(Object.keys(filters).find((key) => filters[key] === operator), intl);
  return (
    <CohortFilterValue
      category={category}
      code={code}
      value={translated.text}
      canRead={canRead}
      canEdit={canEdit}
      title={translated.description}
      width={width}
    />
  );
};

export default connect(mapStateToProps)(QueryFilterOperatorCell);
